import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyClose = (eventCategory: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "close",
        event_category: eventCategory
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyClose = (eventCategory: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "close",
        event_category: eventCategory
    };

    hitGoogleTagManager(gtmData);
};
